import { CLOSED_CURLY_BRACKET, OPEN_CURLY_BRACKET } from 'constants/textFieldBuilder';

export const checkIsBracketsOpen = string => {
  return [...string].reduce((acc, char) => {
    if (char === OPEN_CURLY_BRACKET) {
      acc += 1;
    }

    if (char === CLOSED_CURLY_BRACKET) {
      acc -= 1;
    }

    return acc;
  }, 0);
};
